import React, { Component } from "react";
import './../../styles/home/contact.css'; 
import axios from "axios";

class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showSuccessPopup: false,
      showErrorPopup: false,
      nombre: '',
      email: '',
      mensaje: ''
    };
  }

  resetForm = () => {
    this.setState({
      nombre: '',
      email: '',
      mensaje: ''
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const nombre = formData.get('nombre');
    const email = formData.get('email');
    const mensaje = formData.get('mensaje');
  
    console.log(nombre, email, mensaje);
  
    if (nombre && email && mensaje) {
      axios.post(`${process.env.REACT_APP_API_URL}/contact/save`, {
        nombre: nombre,
        email: email,
        mensaje: mensaje
      })      
      .then(response => {
        console.log(response.data.message);
        return axios.post(`${process.env.REACT_APP_API_URL}/email/send`, {
          destinatario: email,
          asunto: "Gracias por contactar con Noi Donostia",
          contenido: `
            ¡Gracias por contactar con Noi Donostia!
        
            Tu mensaje:
            ${mensaje}
        
            Será procesado lo antes posible y nos pondremos en contacto contigo con la mayor brevedad posible.
        
            Saludos cordiales,
            Noi Donostia`
        });        
      })
      .then(emailResponse => {
        if (emailResponse.data.success) {
          // Si la operación fue exitosa, muestra el mensaje de éxito
          this.setState({ showSuccessPopup: true });
          this.resetForm();
          setTimeout(() => {
            this.setState({ showSuccessPopup: false });
          }, 3000);
        } else {
          // Si la operación falló, muestra el mensaje de error
          this.setState({ showErrorPopup: true });
          setTimeout(() => {
            this.setState({ showErrorPopup: false });
          }, 5000);
        }
      })
      .catch(error => {
        console.error(error);
        this.setState({ showErrorPopup: true });
        setTimeout(() => {
          this.setState({ showErrorPopup: false });
        }, 5000);
      });
    } else {
      console.error('Uno o más campos del formulario están vacíos');
    }
  };
  

  render() {
    return (
      <div className="contact-component">
        <div className="contact-container-home">          
          <div className="form-column">
            <h2>¿Alguna duda?</h2>
            <div className="empty-div"></div>
            <p>No dudes en ponerte en contacto con nosotros y la intentaremos resolver con la mayor brevedad prosible.</p>
            <form className="contact-form" onSubmit={this.handleSubmit}>
              <div className="input-wrapper">
                <input className="contact-input" type="text" name="nombre" placeholder="" required />
                <label className="contact-label">Nombre</label>
              </div>
              <div className="input-wrapper">
                <input className="contact-input" type="text" name="email" placeholder="" required />
                <label className="contact-label">Correo electrónico</label>
              </div>
              <div className="input-wrapper">
                <textarea className="contact-input" name="mensaje" placeholder="" rows="5" value={this.state.mensaje} onChange={(event) => this.setState({ mensaje: event.target.value })} required />
                <label className="contact-label">Mensaje</label>
              </div>
              <button className="button" type="submit">Enviar</button>                           
            </form>          
          </div>
          <div className="text-column">            
            <div className="contact-options">
              <div className="footer-location">
                  <span className="material-symbols-outlined">location_on</span>
                  <p>Donostia San-Sebastián</p>               
              </div>                    
              <div className="footer-mail">
                  <span className="material-symbols-outlined">mail</span>
                  <p><a href="mailto:noidonostia@gmail.com">noidonostia@gmail.com</a></p>
              </div>
              <div className="footer-phone">
                  <span className="material-symbols-outlined">call</span>
                  <p><a href="tel:+34624009109">+34 624 00 91 09</a></p>
              </div>
            </div>
          </div>
        </div>    
        {this.state.showSuccessPopup && (
          <div className="success-message">Tu mensaje se ha enviado correctamente. En breves recibirá un correo con la confirmación. </div>
        )}    
        {this.state.showErrorPopup && (
          <div className="error-message">Error inesperado. Por favor, revisa el formulario o ponte en contacto con nosotros vía email o teléfono. </div>
        )}   
      </div>
    );
  }
}

export default Contact;
